import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/import-mutation-bank/importMutationBankAction";
import * as uiHelpers from "../ImportMutationBankUIHelpers";

import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useImportMutationBankUIContext } from "../ImportMutationBankUIContext";
import { RoleChecker } from "../../../../../RoleChecker";
import moment from "moment";
// import { ToastContainer } from 'react-toastify';

const ImportMutationBankTable = () => {
  // ImportMutationBank UI Context
  const importMutationImportMutationBankUIContext = useImportMutationBankUIContext();
  const importMutationImportMutationBankUIProps = useMemo(() => {
    return {
      queryParams: importMutationImportMutationBankUIContext.queryParams,
      setQueryParams: importMutationImportMutationBankUIContext.setQueryParams,
      openEditImportMutationBankPage:
        importMutationImportMutationBankUIContext.openEditImportMutationBankPage,
    };
  }, [importMutationImportMutationBankUIContext]);

  // Getting curret state of importMutationImportMutationBank list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.importMutationImportMutationBanks }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(
      actions.fetchImportMutationBanks(
        importMutationImportMutationBankUIProps.queryParams
      )
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importMutationImportMutationBankUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "importMutationImportMutationBank");

  // Table columns
  const columns = [
    {
      dataField: "bank_account.bank.name",
      text: "Bank",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "bank_account.account_number",
      text: "No Rekening",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "created_at",
      text: "Tanggal Import",
      sort: true,
      formatter: (cell) => {
        return moment(cell).format("YYYY-MM-DD");
      },
    },
    {
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditImportMutationBankPage:
          importMutationImportMutationBankUIProps.openEditImportMutationBankPage,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: importMutationImportMutationBankUIProps.queryParams.pageSize,
    page: importMutationImportMutationBankUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  importMutationImportMutationBankUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default ImportMutationBankTable;
